import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useSubscriptionContext } from "Bands/contexts";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, IBandSubscriptionRequest } from "Bands/types";
import { IAPIState } from "shared/types";
import { useBandRoute, useClearActionMetaOnUnMount } from ".";
import { BAND_PATHS } from "Bands/router";

export const useCreateBandSubscription = () => {
  const { selectedBilling, redirectToStripe } = useSubscriptionContext();

  const { api: apiMeta, createdItem } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createBandSubscription)
  );

  useClearActionMetaOnUnMount(BAND_ACTIONS.createBandSubscription);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      redirectToStripe({
        subscriptionRequest: createdItem as unknown as IBandSubscriptionRequest,
        companyId: selectedBilling?.id || "",
      });
    }
  }, [apiMeta, createdItem, selectedBilling, redirectToStripe]);

  // custom subscription
  const { pushRoute } = useBandRoute();

  const { api: customSubscriptionApiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.requestCustomSubscription)
  );

  useClearActionMetaOnUnMount(BAND_ACTIONS.requestCustomSubscription);

  useEffect(() => {
    if (customSubscriptionApiMeta?.status === IAPIState.succeeded) {
      pushRoute(BAND_PATHS.SUBSCRIPTION_PENDING);
    }
  }, [customSubscriptionApiMeta, pushRoute]);

  return { apiMeta, customSubscriptionApiMeta };
};
